// extracted by mini-css-extract-plugin
module.exports = {"whyChoose":"WhyChoose-module--whyChoose--3zs-c","column":"WhyChoose-module--column--mE8Of"};